import type { ReactNode } from 'react';
import styles from './ResultStates.module.css';

/**
 * Loading and empty pieces for result lists. Skeletons are drawn from SkeletonBars, and
 * EmptyState lays its message over a faded, still copy of that same skeleton, so a list
 * keeps its shape when loading ends with no results.
 */

/** A shimmering placeholder bar. It stops shimmering inside an EmptyState ghost. */
export function SkeletonBar({ width = '100%', height = 12, radius }: {
  width?: number | string;
  height?: number;
  radius?: number;
}) {
  return <span className={styles.bar} style={{ width, height, borderRadius: radius }} />;
}

/**
 * Empty result: an icon and message over `ghost`, the section's loading skeleton.
 * The message is the Flutter GenericWidget.noRecords() text.
 */
export function EmptyState({ message, ghost, icon }: {
  message: string;
  ghost: ReactNode;
  icon?: ReactNode;
}) {
  return (
    <div className={styles.empty} role="status">
      <div className={styles.ghost} aria-hidden="true">{ghost}</div>
      <div className={styles.overlay}>
        <div className={styles.message}>
          <span className={styles.icon} aria-hidden="true">{icon ?? <BriefcaseIcon />}</span>
          <p className={styles.text}>{message}</p>
        </div>
      </div>
    </div>
  );
}

function BriefcaseIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2.5" y="6" width="15" height="11" rx="1.5" />
      <path d="M7 6V4.5A1.5 1.5 0 0 1 8.5 3h3A1.5 1.5 0 0 1 13 4.5V6M2.5 10.5h15" />
    </svg>
  );
}
